var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcRetry(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.769,
    height: 26.77,
    viewBox: "0 0 26.769 26.77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic-retry",
    transform: "translate(-0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4523",
    "data-name": "Group 4523",
    transform: "translate(1.477)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4522",
    "data-name": "Group 4522"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2404",
    "data-name": "Path 2404",
    d: "M52.58,3.693a1.046,1.046,0,0,0-1.136.946L51.3,6.159a13.2,13.2,0,0,0-22.953,1.1,1.046,1.046,0,1,0,1.863.951,11.117,11.117,0,0,1,19.34-.922L48.063,6.224a1.046,1.046,0,1,0-1.216,1.7l4.521,3.229a1.046,1.046,0,0,0,1.649-.756l.508-5.57A1.046,1.046,0,0,0,52.58,3.693Z",
    transform: "translate(-28.237)",
    fill: "#f26122"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4525",
    "data-name": "Group 4525",
    transform: "translate(0.001 15.419)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4524",
    "data-name": "Group 4524",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2405",
    "data-name": "Path 2405",
    d: "M24.724,297.6a1.046,1.046,0,0,0-1.407.456,11.117,11.117,0,0,1-19.34.922l1.491,1.065a1.046,1.046,0,1,0,1.216-1.7l-4.521-3.229a1.047,1.047,0,0,0-1.649.756l-.508,5.57a1.046,1.046,0,1,0,2.083.19l.139-1.52A13.2,13.2,0,0,0,25.18,299,1.046,1.046,0,0,0,24.724,297.6Z",
    transform: "translate(-0.001 -294.913)",
    fill: "#f26122"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRetry);
export default __webpack_public_path__ + "static/media/ic-retry.9a862b63.svg";
export { ForwardRef as ReactComponent };